import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BasicDetailsForm } from '@models/SIO/BasicDetails.model';
import { CoverageForm } from '@models/SIO/Coverage.model';
import { SQSPocketResponse } from '@models/SQSPocketRequest.model'
import { IOccupation } from '../model';

export interface Step1State {
  basicDetails: BasicDetailsForm | null;
  coverage: CoverageForm | null;
  sqsQuotation: SQSPocketResponse | null;
  appliedPromoCode: string;
  occupationCode: string | null;
  occupation: IOccupation | null;
  quoteRawResponse: object | null;
  quoteRawRequest: object | null;
  isCompleted: boolean;
  transactionId: string;
}

const initialState: Step1State = {
  basicDetails: null,
  coverage: new CoverageForm(null),
  sqsQuotation: null,
  appliedPromoCode: '',
  occupationCode: null,
  quoteRawResponse: null,
  quoteRawRequest: null,
  occupation: null,
  isCompleted: false,
  transactionId: '',
}

const step1Slice = createSlice({
  name: 'SIO-Step1',
  initialState,
  reducers: {
    updateBasicDetails: (state, action: PayloadAction<BasicDetailsForm>) => {
      state.basicDetails = action.payload
    },
    updateCoverage: (state, action: PayloadAction<CoverageForm>) => {
      state.coverage = action.payload
    },
    updateSQSQuotation: (state, action: PayloadAction<SQSPocketResponse>) => {
      state.sqsQuotation = action.payload
    },
    updatePromoCode: (state, action: PayloadAction<string>) => {
      state.appliedPromoCode = action.payload
    },
    updateOccupationCode: (state, action: PayloadAction<string>) => {
      state.occupationCode = action.payload
    },
    updateOccupation: (state, action: PayloadAction<IOccupation>) => {
      state.occupation = action.payload
    },
    updateQuoteResponse: (state, action: PayloadAction<object>) => {
      state.quoteRawResponse = action.payload
    },
    updateQuoteRequest: (state, action: PayloadAction<object>) => {
      state.quoteRawRequest = action.payload
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateTransactionId: (state,action: PayloadAction<string>)=>{
      state.transactionId = action.payload
    }
  },
  extraReducers: {}
})

export const { 
  updateBasicDetails,
  updateCoverage,
  updateSQSQuotation,
  updatePromoCode,
  updateOccupation,
  updateOccupationCode,
  updateQuoteResponse,
  updateQuoteRequest,
  completeStep,
  updateTransactionId
} = step1Slice.actions;

export default step1Slice.reducer;